<i18n lang="yaml">
fi:
  title: Kuittien hallinta, kulukorvaukset ja kirjanpitoautomaatio
  description: Maksuni automatisoi kuittien keruun, kulukorvaukset ja kirjanpidon - vähemmän manuaalista työtä, enemmän aikaa olennaiseen.
sv:
  title: Kvittohantering, utlägg och automatiserad bokföring
  description: Med Maksuni slipper du manuell hantering. Digitalisera kvitton, förenkla utlägg och automatisera bokföringen.
en:
  title: Receipt Management, Reimbursements & Accounting Automation
  description: Maksuni streamlines receipt capture, expense reimbursements, and accounting workflows - so your team spends less time on admin.
</i18n>

<template lang="pug">
nuxt-layout
  nuxt-page
</template>

<script setup>
const { t } = useI18n()
const route = useRoute()
const localeHead = useLocaleHead()
const config = useRuntimeConfig()

// Use onMounted to handle DOM operations
onMounted(() => {
  // Watch page meta heroBg and change the body class
  watch(
    () => route.meta.bodyBackgroundColor,
    (backgroundColor) => {
      if (backgroundColor) {
        document.body.style.backgroundColor = backgroundColor
      }
    },
    { immediate: true }
  )
})

useHead({
  title: t('title'),
  htmlAttrs: {
    lang: localeHead.value.htmlAttrs.lang || 'fi-FI',
    dir: localeHead.value.htmlAttrs.dir || 'ltr'
  },
  meta: [
    ...(localeHead.value.meta || []),
    {
      name: 'description',
      content: t('description')
    },
    {
      name: 'og:title',
      property: 'og:title',
      content: `Maksuni.fi | ${t('title')}`
    },
    {
      name: 'og:description',
      property: 'og:description',
      content: t('description')
    },
    {
      name: 'twitter:title',
      property: 'twitter:title',
      content: `Maksuni.fi | ${t('title')}`
    },
    {
      name: 'twitter:description',
      property: 'twitter:description',
      content: t('description')
    }
  ]
})
</script>
